// extracted by css-extract-rspack-plugin
export default {"rcLabelWidth":"rcLabelWidth-bB5VFw","iconsMargin":"iconsMargin-mjztRG"};